export default {
      id: "smile-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "sprite.svg#smile-usage",
      toString: function () {
        return this.url;
      }
    }